import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { Subscription } from 'rxjs/Subscription'; 
import { UserLoginService } from '../../service/user/user.login.service';
import { StateInternalPipe } from './state-internal.pipe';
import { DataService } from '../../service/data';
import { Observable } from 'rxjs';
import { Angulartics2Vdgm } from '../../providers/Angulartics2Vdgm';
import 'rxjs/add/operator/first';

@Injectable()
export class StateUserPipe {

    private isServer: boolean;
    private _loginPipe: BehaviorSubject<String>;
    private existingStats: object;
    private existingFavs: any;

    constructor(
        @Inject(APP_SETTINGS) private settings: any,
        @Inject(PLATFORM_ID) private platformId: string,
        private apiService: DataService,
        private stateInternal: StateInternalPipe,
        private loginService : UserLoginService,
        private analytics: Angulartics2Vdgm
    ) { 
        this.isServer = isPlatformServer(this.platformId);
        if ( !this.isServer ){
            this._loginPipe = this.loginService.loginState;
            this._loginPipe.subscribe(res => {
              if( res == "token_received"){
                this.processExistingUserVideoStats()
                  .first()
                  .subscribe(pushed => {
                    this._loginPipe.next("stats_pushed");
                    //console.log("pushed");
                  })
              }
            });
            this._loginPipe.subscribe(res => {
              if( res == "stats_pushed"){
                this.getUserCmsInfo()
                  .first()
                  .subscribe(pushed => {
                    this._loginPipe.next("stats_retrieved");
                    this._loginPipe.complete();
                    //console.log("retrieved");
                  })
              }
            });
          }
    }

    public getUserProfile(): Observable<any>{
        let obs =  this.apiService.getRouterData({}, this.settings.PROFILE_API_ROUTE, false)
        .map(res => {
            if (res && res.user) {
                this.stateInternal.setInternalStateValue('user_profile', res.user);
                if (!this.isServer){
                    this.analytics.setUsername(res.user.id, res.user.email);
                }
            }
            return res
        });
        return obs;
    }

    public getUserDevices(): Observable<any> {
        let obs =  this.apiService.getRouterData({}, this.settings.USER_DEVICES_API_ROUTE, false) 
        .map( res => {
          this.stateInternal.setInternalStateValue('user_devices', res.data);
        });
        return obs;
    }
  
    public getFavorites() : Observable<any>{
        //return this.apiService.getData({}, this.settings.FAVORITES_API_ROUTE, 0, false, false, false );
        let obs =  this.apiService.getRouterData({}, this.settings.FAVORITES_API_ROUTE, false)
        .map( res => {
            let result = res.data;
            Object.keys(result).forEach( key=> {
                result[key]['pushed'] = true
            });
            this.existingFavs = result;
            this.pushToStore('favorites');
        });
        return obs;
    }

    public patchProfile(profile: any){
        return this.apiService.patchData(this.settings.PROFILE_API_ROUTE, {user: profile})
        .map( res => {
            //let result = res;
            //console.log(res);
            return res;
        });
        //return obs;
    }
  
    private syncFavorites(favorite, action){
        const existingList = this.stateInternal.getInternalStateValue("favorites");
        let cleanList = existingList.filter(item => item.meta.unique_id !== favorite.meta.unique_id);
        if (action){
            cleanList.push(favorite);
        }
        this.stateInternal.setInternalStateValue("favorites", cleanList);
    }

    public getExistingUserVideoStatsAsObservable() : Observable<any> {
        return this.apiService.getRouterData({}, this.settings.VIDEO_STATS_API_ROUTE)  
    }

    public getExistingUserVideoStats() : Observable<any>{
        let obs = this.apiService.getRouterData({}, this.settings.VIDEO_STATS_API_ROUTE, false)
        .map( res => {
        let result = res.data;
        Object.keys(result).forEach( key=> {
            result[key]['pushed'] = true
        });
        this.existingStats = result
        this.pushToStore('video_stats');
        });
        return obs;
    }
    public updateVideoStats( statObj ){
        let stats = this.stateInternal.getInternalStateValue( "video_stats" )
        if( stats == null){
            this.stateInternal.setInternalStateValue( "video_stats", statObj);
        }else{
            let update = Object.assign({},stats);

            Object.keys(statObj).forEach( id => {
                update[id] = statObj[id];
            })
            this.stateInternal.setInternalStateValue("video_stats", update);
        }
    }

    public pushToStore(key: string){
        ///remove faulty entries due to bad video data
        if (key === 'video_stats'){
            delete this.existingStats['undefined'];
        }
        this.stateInternal.setInternalStateValue(key, key === 'video_stats' ? this.existingStats : this.existingFavs);
    }

    public getUserCmsInfo(){
        return Observable.forkJoin(
            [
                this.getFavorites(),
                this.getExistingUserVideoStats(),
                this.getUserProfile(),
                this.getUserDevices()
            ]
        );
    }

    public getUserOTTInfo(){
        return Observable.forkJoin(
            [
                this.getFavorites(),
                this.getExistingUserVideoStats()
            ]
        );
    }
    
    public addOrRemoveFavorite(favoriteObj : any){
        const slimMeta = {
            meta:{
            unique_id : favoriteObj.item.meta.unique_id
            }
        }; 
        if (favoriteObj.add){
            this.apiService.postData(this.settings.FAVORITES_API_ROUTE,{"favorites":  [slimMeta]})
            .first()
            .subscribe()
        }else {
            this.apiService.deleteData(this.settings.FAVORITES_API_ROUTE, favoriteObj.item.meta.unique_id)
            .first()
            .subscribe()
        }
        favoriteObj.item['pushed'] = true;
        this.syncFavorites(favoriteObj.item, favoriteObj.add);
    }

    private removeRegisteredDeviceInternal(deviceId){
        const existingList = this.stateInternal.getInternalStateValue("user_devices");
        const cleanList = existingList.filter(item => item.uuid !== deviceId);
        this.stateInternal.setInternalStateValue("favorites", cleanList);
    }

    public removeRegisteredDevice(deviceId){
        const self = this;
        this.apiService.deleteData(this.settings.USER_DEVICES_API_ROUTE, deviceId)
            .first()
            .subscribe(res =>{
                self.removeRegisteredDeviceInternal(deviceId);
            })
    }

    public changePassword(newPassword: string){
        const passwordObject = {"new_password": newPassword}
        return this.apiService.putData(this.settings.PASSWORD_CHANGE_ROUTE, {user: passwordObject})
        .map( res => {
            //let result = res;
            //console.log(res);
            return res;
        });
    }

    public processExistingUserVideoStats(){
        let localStorage : any;
        let obs;
        
        if ( window && window.localStorage.getItem("video_stats") != "undefined" ){
            localStorage = JSON.parse(window.localStorage.getItem("video_stats")) as  any;
            window.localStorage.removeItem("video_stats");
        }

        this.existingStats =  localStorage ?  localStorage :  this.stateInternal.getInternalStateValue("video_stats") as Array<any>;

        if (this.existingStats ){
            const unpushedStats = Object.keys(this.existingStats).filter(id => !this.existingStats[id].pushed);
            let newStats = {};
            unpushedStats.forEach( id => {
                newStats[id] = this.existingStats[id];
            });
            obs  = this.apiService.postData(this.settings.VIDEO_STATS_API_ROUTE,{"watched_videos":  {data: newStats}});
        }else{
            obs = Observable.of({});
        }
        return obs;
    } 

    public isLoggedIn(){
        return this.loginService.isLoggedIn;
    }

    public setLoginState(state: boolean){
        this.loginService.setLoginState(state);
    }

    public login(){
        this.loginService.login();
    }
}



// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/state-user.pipe.ts